import QRCode from "qrcode";
import { useEffect, useState } from "react";

import type { TshirtSize } from "@/db/schema/payments";
import { pickupCode } from "@/utils/membership";

import { Modal, ModalHeading } from "../base/modal";
import { TshirtSizeDisplay } from "./tshirt-size-display";

export function TshirtPickupModal({
  isOpen,
  onOpenChange,
  membershipId,
  tshirtSize,
}: {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  membershipId: number;
  tshirtSize: TshirtSize | null;
}) {
  const [qrDataUrl, setQrDataUrl] = useState<string | null>(null);
  const code = pickupCode(membershipId);
  const baseUrl = (
    import.meta.env.VITE_BASE_URL || window.location.origin
  ).replace(/\/$/, "");
  const url = `${baseUrl}/tshirt-pickup/${membershipId}`;

  useEffect(() => {
    QRCode.toDataURL(url, {
      errorCorrectionLevel: "H",
      width: 280,
      margin: 2,
    }).then(setQrDataUrl);
  }, [url]);

  return (
    <Modal isOpen={isOpen} onOpenChange={onOpenChange}>
      <div className="flex flex-col items-center gap-4 p-6">
        <ModalHeading size="md">T-Shirt Pickup</ModalHeading>

        {qrDataUrl && (
          <img
            src={qrDataUrl}
            alt="T-shirt pickup QR code"
            className="h-56 w-56"
          />
        )}

        <div className="font-mono text-4xl font-bold tracking-widest">
          {code}
        </div>

        <TshirtSizeDisplay
          membershipId={membershipId}
          tshirtSize={tshirtSize}
        />

        <p className="text-center text-sm">
          Show this to a tournament director to pick up your t-shirt.
        </p>
      </div>
    </Modal>
  );
}
